import { render, staticRenderFns } from "./ActionsForm.vue?vue&type=template&id=18517fe8&scoped=true&"
import script from "./ActionsForm.vue?vue&type=script&lang=js&"
export * from "./ActionsForm.vue?vue&type=script&lang=js&"
import style0 from "./ActionsForm.vue?vue&type=style&index=0&id=18517fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18517fe8",
  null
  
)

export default component.exports